import { TQuestionDifficulty } from '../store/QuestionSlice';
import Countries from './Countries';
import {
  ON_BEHALF_USER_ROLES,
  TOnBehalfOfUserRole,
} from '../store/V2/SectionSlice';
import {
  TZoomMeetingRequestRequestedByRole,
  ZOOM_MEETING_REQUEST_REQUESTED_BY_ROLES,
} from '../store/V2/ZoomRequestsSlice';

export interface ISelectedOption {
  label: string;
  value: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export interface ISelectedDataOption {
  selectedItem: ISelectedOption;
  options: ISelectedOption[];
}

export const allSelectedOption: ISelectedOption = {
  label: 'All',
  value: 'All',
};

export const defaultEmptySelectedOption: ISelectedOption = {
  label: '',
  value: '',
};

export const defaultSelectedDataOption: ISelectedDataOption = {
  selectedItem: defaultEmptySelectedOption,
  options: [],
};

export const questionDifficultyOptions: Array<TQuestionDifficulty> = [
  'EASY',
  'MEDIUM',
  'HARD',
];

export const adminCancellationReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const adminRescheduleReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const classCancellationReasonOptions = [
  { value: 'Schedule Changes', label: 'Schedule Changes' },
  { value: 'School Events', label: 'School Events' },
  { value: 'Health Reasons', label: 'Health Reasons' },
  { value: 'Vacations', label: 'Vacations' },
];

export const rescheduleReasonOptions = [
  { label: 'Sickness', value: 'Sickness' },
  { label: 'Due to a lesson Overlap', value: 'Due to a lesson Overlap' },
  { label: 'Time Zone change', value: 'Time Zone change' },
  { label: 'Unforeseen Circumstance', value: 'Unforeseen Circumstance' },
  { label: 'School Activity', value: 'School Activity' },
  { label: 'Technical issue', value: 'Technical issue' },
  { label: 'Duration Change', value: 'Duration Change' },
];

export const classDurationsInMinutes = [
  15,
  30,
  45,
  60,
  75,
  90,
  105,
  120,
  135,
  150,
  165,
  180,
];

export const classDurationOptions = classDurationsInMinutes.map((minutes) => {
  const _hours = Math.floor(minutes / 60);
  const _minutes = minutes % 60;

  let label = '';

  if (_hours) {
    label += `${_hours} h `;
  }

  if (_minutes) {
    label += `${_minutes} m`;
  }

  return {
    label,
    value: minutes.toString(),
  };
});

export const countriesOptions = Countries.map((item) => ({
  label: item.name,
  value: item.value,
}));

export const teachingStatusOptions = [
  { value: 'Full-time Tutor', label: 'Full-time Tutor' },
  { value: 'Part-time Tutor', label: 'Part-time Tutor' },
  { value: 'Ex-MOE SG School', label: 'Ex-MOE SG School' },
  { value: 'Ex-School Teacher', label: 'Ex-School Teacher' },
  {
    value: 'Teacher current School Teacher',
    label: 'Teacher current School Teacher',
  },
  { value: 'Current MOE', label: 'Current MOE' },
];

export const availabilityOptions = [
  { value: 'available', label: 'Available for Trials' },
  { value: 'notAvailable', label: 'Unavailable for Trials' },
  { value: 'onABreak', label: 'On a Break' },
  { value: 'resigned', label: 'Resigned' },
  // { value: 'automatedTrainingStage', label: 'Automated training stage' },
  { value: 'demoStage', label: 'Demo Stage' },
  { value: 'notAvailableAdmin', label: 'Unavailable for Trials (Admin)' },
  { value: 'notInterested', label: 'Not Interested for Trials' },
];

export const yesOrNoBoolOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const noticePeriodOptions = Array.from({ length: 24 }, (_, i) => ({
  label: `${i + 1} Hour${i + 1 > 1 ? 's' : ''}`,
  value: i + 1,
}));

const tutorStrengths = [
  'Strong Communication Skills',
  'Patient',
  'Good Rapport with Students',
  'Own Teaching materials',
  'Motivating & friendly',
  "Customize Tuition for Student's needs",
  'Firm Tutor',
  'Passionate',
  'Eager to help',
  'Interactive teaching style',
  'Active Listener',
  'Active teacher',
  'Strong teaching resources',
];

export const strengthOptions = tutorStrengths.map((strength) => ({
  value: strength,
  label: strength,
}));

export const LANGUAGES = [
  'Abkhaz',
  'Afar',
  'Afrikaans',
  'Akan',
  'Albanian',
  'Amharic',
  'Arabic',
  'Aragonese',
  'Armenian',
  'Assamese',
  'Avaric',
  'Avestan',
  'Aymara',
  'Azerbaijani',
  'Bambara',
  'Bashkir',
  'Basque',
  'Belarusian',
  'Bengali',
  'Bihari',
  'Bislama',
  'Bosnian',
  'Breton',
  'Bulgarian',
  'Burmese',
  'Catalan, Valencian',
  'Chamorro',
  'Chechen',
  'Chichewa, Chewa, Nyanja',
  'Chinese',
  'Chuvash',
  'Cornish',
  'Corsican',
  'Cree',
  'Croatian',
  'Czech',
  'Danish',
  'Divehi, Dhivehi, Maldivian',
  'Dutch',
  'English',
  'Esperanto',
  'Estonian',
  'Ewe',
  'Faroese',
  'Fijian',
  'Finnish',
  'French',
  'Fula, Fulah, Pulaar, Pular',
  'Galician',
  'Georgian',
  'German',
  'Greek, Modern',
  'Guaraní',
  'Gujarati',
  'Haitian, Haitian Creole',
  'Hausa',
  'Hebrew (modern)',
  'Herero',
  'Hindi',
  'Hiri Motu',
  'Hungarian',
  'Interlingua',
  'Indonesian',
  'Interlingue',
  'Irish',
  'Igbo',
  'Inupiaq',
  'Ido',
  'Icelandic',
  'Italian',
  'Inuktitut',
  'Japanese',
  'Javanese',
  'Kalaallisut, Greenlandic',
  'Kannada',
  'Kanuri',
  'Kashmiri',
  'Kazakh',
  'Khmer',
  'Kikuyu, Gikuyu',
  'Kinyarwanda',
  'Kirghiz, Kyrgyz',
  'Komi',
  'Kongo',
  'Korean',
  'Kurdish',
  'Kwanyama, Kuanyama',
  'Latin',
  'Luxembourgish, Letzeburgesch',
  'Luganda',
  'Limburgish, Limburgan, Limburger',
  'Lingala',
  'Lao',
  'Lithuanian',
  'Luba-Katanga',
  'Latvian',
  'Manx',
  'Macedonian',
  'Malagasy',
  'Malay',
  'Malayalam',
  'Maltese',
  'Māori',
  'Marathi (Marāṭhī)',
  'Marshallese',
  'Mongolian',
  'Nauru',
  'Navajo, Navaho',
  'Norwegian Bokmål',
  'North Ndebele',
  'Nepali',
  'Ndonga',
  'Norwegian Nynorsk',
  'Norwegian',
  'Nuosu',
  'South Ndebele',
  'Occitan',
  'Ojibwe, Ojibwa',
  'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
  'Oromo',
  'Oriya',
  'Ossetian, Ossetic',
  'Panjabi, Punjabi',
  'Pāli',
  'Persian',
  'Polish',
  'Pashto, Pushto',
  'Portuguese',
  'Quechua',
  'Romansh',
  'Kirundi',
  'Romanian, Moldavian, Moldovan',
  'Russian',
  'Sanskrit (Saṁskṛta)',
  'Sardinian',
  'Sindhi',
  'Northern Sami',
  'Samoan',
  'Sango',
  'Serbian',
  'Scottish Gaelic, Gaelic',
  'Shona',
  'Sinhala, Sinhalese',
  'Slovak',
  'Slovene',
  'Somali',
  'Southern Sotho',
  'Spanish, Castilian',
  'Sundanese',
  'Swahili',
  'Swati',
  'Swedish',
  'Tamil',
  'Telugu',
  'Tajik',
  'Thai',
  'Tigrinya',
  'Tibetan Standard, Tibetan, Central',
  'Turkmen',
  'Tagalog',
  'Tswana',
  'Tonga (Tonga Islands)',
  'Turkish',
  'Tsonga',
  'Tatar',
  'Twi',
  'Tahitian',
  'Uighur, Uyghur',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Venda',
  'Vietnamese',
  'Volapük',
  'Walloon',
  'Welsh',
  'Wolof',
  'Western Frisian',
  'Xhosa',
  'Yiddish',
  'Yoruba',
  'Zhuang, Chuang',
];

export const languageOptions = LANGUAGES.map((item) => ({
  value: item,
  label: item,
}));

const Proficiency = ['Native', 'Intermediate', 'Advanced'];

export const proficiencyOptions = Proficiency.map((pro) => ({
  value: pro,
  label: pro,
}));

export type TOnBehalfOfUserRoleOption = {
  label: TOnBehalfOfUserRole;
  value: TOnBehalfOfUserRole;
};

export const onBehalfOfuserRoleOptions: TOnBehalfOfUserRoleOption[] = (Object.keys(
  ON_BEHALF_USER_ROLES
) as TOnBehalfOfUserRole[]).map((item) => ({
  label: item,
  value: item,
}));

export type TZoomMeetingRequestRequestedByRoleOption = {
  label: TZoomMeetingRequestRequestedByRole;
  value: TZoomMeetingRequestRequestedByRole;
};

export const zoomMeetingRequestRequestedByRoleOptions: TZoomMeetingRequestRequestedByRoleOption[] = Object.values(
  ZOOM_MEETING_REQUEST_REQUESTED_BY_ROLES
).map((item) => ({
  label: item as TZoomMeetingRequestRequestedByRole,
  value: item as TZoomMeetingRequestRequestedByRole,
}));
